import binUrl from "./tdth.bin?url";

/**
 * AFAD Türkiye Deprem Tehlike Haritası (TDTH) ızgarası: 0,1° aralıklı SS/S1, DD-1..DD-4 (scripts/tdth/build.py üretir).
 * Çift doğrusal enterpolasyon; AFAD detay raporlarıyla Adana birebir, Çanakkale ~%1 → "yaklaşık" olarak sunulur.
 */
export type DdLevel = "DD-1" | "DD-2" | "DD-3" | "DD-4";
export interface TdthValues { SS: number; S1: number }

const LON0 = 24.55, LAT0 = 34.25, NX = 215, NY = 88, STEP = 0.1;
let grid: Promise<Uint16Array> | null = null;
const load = (): Promise<Uint16Array> => (grid ??= fetch(binUrl).then((r) => { if (!r.ok) throw new Error(`TDTH ${r.status}`); return r.arrayBuffer(); }).then((b) => new Uint16Array(b)));

/** Izgaradan değer; nokta ızgara dışındaysa ya da komşu hücrelerden biri boşsa (deniz/sınır dışı) null. */
export function tdthAt(g: Uint16Array, lat: number, lon: number, level: DdLevel): TdthValues | null {
  const fx = (lon - LON0) / STEP, fy = (lat - LAT0) / STEP;
  const x0 = Math.floor(fx), y0 = Math.floor(fy);
  if (x0 < 0 || y0 < 0 || x0 + 1 >= NX || y0 + 1 >= NY) return null;
  const tx = fx - x0, ty = fy - y0, lv = Number(level.slice(3)) - 1;
  const at = (p: number): number | null => {
    const base = (lv * 2 + p) * NY * NX;
    const i = base + y0 * NX + x0;
    const a = g[i] ?? 0, b = g[i + 1] ?? 0, c = g[i + NX] ?? 0, d = g[i + NX + 1] ?? 0;
    if (!a || !b || !c || !d) return null;
    return (a * (1 - tx) * (1 - ty) + b * tx * (1 - ty) + c * (1 - tx) * ty + d * tx * ty) / 10000;
  };
  const SS = at(0), S1 = at(1);
  return SS === null || S1 === null ? null : { SS: Math.round(SS * 1000) / 1000, S1: Math.round(S1 * 1000) / 1000 };
}

export async function lookupTdth(lat: number, lon: number, level: DdLevel = "DD-2"): Promise<TdthValues | null> {
  return tdthAt(await load(), lat, lon, level);
}
